import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';
import cx from 'classnames';
import { Image } from 'react-bootstrap';
import { EditorContext } from 'components/Editor';
import { SeekSearchBox, SessionContainer } from '@paperflite-marketing/cleverstory-commons';

import styles from './responsiveDesign.module.scss'

export const DesignPreview = ({deviceLayout, widgetProps, seekDesign}) => {
  const editorContext = React.useContext(EditorContext);
  const editor = editorContext.editorSession.id;
  const breakpoint = useSelector((state) => _.get(state, `${editor}.present.breakpoint`));
  const responseDesign = _.get(widgetProps, `properties.${deviceLayout}.responseDesign.type`, "popup");

  return (
    <>
    {deviceLayout == "desktop" &&
      <div className={styles.seekDesktopPreview}>
        <div className={styles.header}>
          <Image className={styles.banner} src={"/images/seekDesign/desktopHeader.png"} />
        </div>

        <div className={styles.previewContent}>
          <div className={styles.previewLayout}></div>
          <div className={styles.previewDesign}>
            <div className={styles.seekSearchBox}>
              <SeekSearchBox
                widgetProps={widgetProps}
                breakpoint={deviceLayout}
              />
            </div>

              {seekDesign === "responseDesign" &&
                <SeekDesignPreview
                  widgetProps={widgetProps}
                  breakpoint={deviceLayout}
                  seekDesign={seekDesign}
                  responseDesign={responseDesign}
                />
              }
          </div>

          <div className={styles.previewGridLayout}>
            <div className={styles.grid}></div>
            <div className={styles.grid}></div>
            <div className={styles.grid}></div>
          </div>
        </div>
      </div>
    }

    {deviceLayout == "mobile" &&
      <div className={styles.seekMobilePreview}>
        <div className={styles.previewContent}>
          <div className={styles.mobilePreview}>
            {seekDesign != 'responseDesign' &&
              <SeekSearchBox
              widgetProps={widgetProps}
              breakpoint={deviceLayout}
              />
            }
            {seekDesign === 'responseDesign' &&
              <div className={styles.previewDesign}>
                <SeekDesignPreview
                  widgetProps={widgetProps}
                  breakpoint={deviceLayout}
                  seekDesign={seekDesign}
                  responseDesign={responseDesign}
                />
              </div>
            }
          </div>
        </div>
      </div>
    }
    </>
  )
}

const SeekDesignPreview = ({widgetProps, breakpoint, responseDesign}) => {
  if(breakpoint === "desktop"){
    switch(responseDesign) {
      case 'inline': {
        return (
          <>
            <div className={styles.responseDesign}>
                <div className={cx(styles.inlineOuterContainer)}> 
                  <div className={styles.overlay}></div>
                    <div className={styles.inlineView}>
                    <div className={styles.seekDesktopPreview}>
                      <SessionContainer 
                        show={true} 
                        breakpoint={breakpoint}
                        widgetProps={widgetProps}
                        preview={true}
                      />
                      </div>
                    </div>
                  </div> 
            </div>
          </>
        )
      }

      case 'popup': {
        return (
          <div className={styles.responseDesign}>
            <div className={cx(styles.popupOuterContainer)}> 
              <div className={styles.overlay}></div>
                <div className={cx(styles.popupView, styles.popupAnimation)}>
                  <div className={styles.pointerEvent}>
                    <SessionContainer 
                      show={true} 
                      breakpoint={breakpoint}
                      widgetProps={widgetProps}
                      preview={true}
                    />
                  </div>
                </div>
              </div> 
          </div>
        )
      }

      case 'slider': {
        return (
          <div className={cx(styles.responseDesign)}>
            <div className={cx(styles.sliderOuterContainer)}> 
              <div className={styles.overlay}></div>
                <div className={cx(styles.sliderView, styles.sliderAnimation)}>
                  <div className={styles.pointerEvent}>
                    <SessionContainer 
                      show={true} 
                      breakpoint={breakpoint}
                      widgetProps={widgetProps}
                      preview={true}
                    />
                    </div>
                </div>
              </div> 
          </div>
        )
      }
    }
  }

  if(breakpoint === "mobile"){
    return (
      <div className={styles.responseDeign}>
        <div className={cx(styles.inlineOuterContaner)}> 
            <div className={styles.inlineView}>
              <SessionContainer
                show={true} 
                breakpoint={breakpoint}
                widgetProps={widgetProps}
                preview={true}
              />
            </div>
          </div> 
      </div>
    )
  }
}